import * as Constants from './Constants' 
 
export const setHelp = (helpKey) => ({ 
  type: Constants.SET_HELP,
  helpKey
}) 

export const clearHelp = (helpKey) => ({ 
  type: Constants.CLEAR_HELP
}) 



// WEBPACK FOOTER //
// ./src/modules/state/help/Actions.js